import React from 'react'
import { MITLoggedOut } from '@mit/hui'

const Logout = (): any => {
  return <MITLoggedOut />
}

export default Logout
